import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => ({
    userData: null,
    accessToken: null,
    refreshToken: null,
    expiresAt: null,
});

const initialState = getInitialState();

const persistConfig = {
    key: "auth",
    storage,
    whitelist: ["userData", 'accessToken', 'refreshToken', 'expiresAt'], // place to select which state you want to persist
};

const applySession = (state, payload = {}) => {
    state.userData = payload.user ?? payload.userData ?? state.userData;
    const responseAccessToken =
        payload.access_token ??
        payload.accessToken ??
        payload.account_token ??
        payload.accountToken;
    state.accessToken = responseAccessToken ?? state.accessToken;
    state.refreshToken = payload.refresh_token ?? payload.refreshToken ?? responseAccessToken ?? state.refreshToken;
    state.expiresAt = payload.expiresAt ?? state.expiresAt;
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setSession: (state, action) => {
            applySession(state, action.payload);
        },
        setUserData: (state, action) => {
            state.userData = action.payload;
        },
        clearSession: () => getInitialState(),
    },
});

export const { setSession, setUserData, clearSession } = authSlice.actions;

export default persistReducer(persistConfig, authSlice.reducer);
